import '@oysterjs/core/apm';
import * as Sentry from '@sentry/react';

import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { client } from './api/client';
import { DashboardContainer } from './components/dashboard';
import * as loaders from './api/loaders';
import * as actions from './api/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import { ErrorBoundary } from '@oysterjs/ui/error-boundary';
import { SignInPage } from './pages/signin';
import { CertificatesPage, CreateCertificatePage } from './pages/certificates';
import { PoliciesPage, PolicyPage } from './pages/policies';
import { byMethod } from '@oysterjs/core/graphql/actions';
import {
  CreateServiceRequestPage,
  ServiceRequestPage,
  ServiceRequestsPage
} from './pages/servicing';

const router = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter)([
  {
    path: '',
    id: 'root',
    loader: merge({ accountUser: loaders.getAccountUser }),
    element: <DashboardContainer />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: '',
        element: <Navigate to="/policies" replace />
      },
      {
        path: 'policies',
        children: [
          {
            path: '',
            loader: merge({ account: loaders.getAccount }),
            element: <PoliciesPage />
          },
          {
            path: ':id',
            loader: merge({
              businessPolicy: loaders.getPolicy
            }),
            element: <PolicyPage />
          }
        ]
      },
      {
        path: 'certificates',
        loader: merge({ account: loaders.getAccount }),
        element: <CertificatesPage />,
        children: [
          {
            path: 'new',
            loader: merge({ createCertificateOptions: loaders.getCreateCertificateOptions }),
            action: byMethod({ POST: actions.clientCreateCertificate }),
            element: <CreateCertificatePage />
          }
        ]
      },
      {
        path: 'servicing',
        loader: merge({ account: loaders.getAccount }),
        element: <ServiceRequestsPage />,
        children: [
          {
            path: ':id',
            loader: merge({ serviceRequest: loaders.getServiceRequest }),
            element: <ServiceRequestPage />
          },
          {
            path: 'new',
            loader: merge({ account: loaders.getAccount }),
            action: byMethod({ POST: actions.createServiceRequest }),
            element: <CreateServiceRequestPage />
          }
        ]
      }
    ]
  },
  {
    path: 'signin',
    element: <SignInPage />
  }
]);

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container!);

root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <RouterProvider router={router} />
    </ApolloProvider>
  </React.StrictMode>
);
